/*
Copyright, 2025, Medidata Solutions Worldwide, Inc. All rights reserved.
 */

import React from 'react'
import ActionsMenu from '../../../shared/ActionsMenu'
import { useFsiActionMenu } from '../../../../hooks/useFsiActionMenu'
import { Document } from '../../../../hooks/useDocumentsListService'

interface DocumentActionMenuProps {
  item: Document
  options?: any
}

export const DocumentActionMenu = ({ item, options = {} }: DocumentActionMenuProps) => {
  const { items, setIsOpen } = useFsiActionMenu(item, options)

  // Add fallback if no items
  if (items.length === 0) {
    items.push({ value: 'ACTION_MENU_NO_ACTION_AVAILABLE', disabled: true })
  }

  return (
    <ActionsMenu
      menuId={`action-menu-document-${item.id}`}
      onToggle={(open: boolean) => {
        setIsOpen(open)
      }}
      items={items}
    />
  )
}
